import { MicrophoneIcon, StopIcon } from '@heroicons/react/24/solid';

const SIZES = {
  hero: {
    button: 'w-24 h-24',
    icon: 'w-10 h-10',
  },
  inline: {
    button: 'w-11 h-11',
    icon: 'w-5 h-5',
  },
};

/**
 * Tap to start, tap to stop. Deliberately not press-and-hold: holding is
 * unusable for a two-minute ramble and breaks the moment the page scrolls.
 *
 * Renders nothing when unsupported — the parent shows the typing fallback.
 */
export default function MicButton({
  listening,
  supported,
  onStart,
  onStop,
  size = 'hero',
  disabled = false,
  className = '',
}) {
  if (!supported) return null;

  const dims = SIZES[size] || SIZES.hero;
  const Icon = listening ? StopIcon : MicrophoneIcon;

  return (
    <button
      type="button"
      onClick={listening ? onStop : onStart}
      disabled={disabled}
      aria-pressed={listening}
      aria-label={listening ? 'Stop recording' : 'Start recording'}
      className={`relative inline-flex items-center justify-center rounded-full text-white shadow-lg transition-all disabled:opacity-40 disabled:cursor-not-allowed ${
        dims.button
      } ${
        listening
          ? 'bg-gradient-to-br from-rose-500 to-red-600'
          : 'bg-gradient-to-br from-indigo-600 to-violet-600 hover:shadow-xl'
      } ${className}`}
    >
      {listening && (
        <>
          <span className="absolute inset-0 rounded-full bg-red-500/40 animate-ping" />
          <span className="absolute inset-0 rounded-full bg-red-500/20 animate-pulse" />
        </>
      )}
      <Icon className={`relative ${dims.icon}`} />
    </button>
  );
}
